import { render, staticRenderFns } from "./clipper-preview.vue?vue&type=template&id=27f958b6&scoped=true&"
import script from "./clipper-preview.vue?vue&type=script&lang=js&"
export * from "./clipper-preview.vue?vue&type=script&lang=js&"
import style0 from "./clipper-preview.vue?vue&type=style&index=0&id=27f958b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f958b6",
  null
  
)

export default component.exports